/* RoughStride — lightweight interactions (no dependencies) */
(function () {
  var body = document.body;
  var header = document.querySelector('[data-header]');
  var toggle = document.querySelector('[data-menu-toggle]');
  var closeBtn = document.querySelector('[data-menu-close]');
  var overlay = document.querySelector('[data-menu-overlay]');
  var drawer = document.querySelector('[data-menu-drawer]');

  function openMenu() {
    body.classList.add('menu-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }
  function closeMenu() {
    body.classList.remove('menu-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  if (toggle) {
    toggle.addEventListener('click', function () {
      body.classList.contains('menu-open') ? closeMenu() : openMenu();
    });
  }
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) closeMenu();
    });
  }
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  // sticky header shadow
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 6) header.classList.add('is-stuck');
      else header.classList.remove('is-stuck');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // quantity steppers (product + cart)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.qty');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val += btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    if (val < (parseInt(input.min, 10) || 1)) val = parseInt(input.min, 10) || 1;
    input.value = val;
    if (btn.getAttribute('data-cart-auto') === 'true') {
      var form = wrap.closest('form');
      if (form) form.submit();
    }
  });

  // ==========================================================================
  // Product page: gallery, variant picker, sticky mobile buy bar
  // ==========================================================================
  (function () {
    var mainImg = document.querySelector('[data-gallery-main]');

    // ---- gallery thumbnails ----
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full && mainImg) mainImg.src = full;
        thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    function syncThumb(src) {
      if (!src) return;
      var base = src.split('?')[0];
      thumbs.forEach(function (t) {
        var f = t.getAttribute('data-full');
        t.setAttribute('aria-current', f && f.split('?')[0] === base ? 'true' : 'false');
      });
    }

    // ---- variant picker ----
    var picker = document.querySelector('[data-variant-picker]');
    var idInput = document.querySelector('[data-variant-id]');
    var dataEl = document.querySelector('[data-variant-data]');
    var variants = [];
    if (dataEl) { try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; } }

    var priceEls = document.querySelectorAll('[data-price]');
    var compareEls = document.querySelectorAll('[data-compare]');
    var discountEls = document.querySelectorAll('[data-discount]');
    var dealEls = document.querySelectorAll('[data-deal]');
    var atcTextEls = document.querySelectorAll('[data-atc-text]');
    var atcBtns = document.querySelectorAll('[data-atc-main],[data-atc-bar]');
    var stageBadge = document.querySelector('[data-stage-badge]');
    var stockText = document.querySelector('[data-stock-text]');

    function setText(list, val) { list.forEach(function (el) { el.textContent = val; }); }
    function toggle(list, show, val) {
      list.forEach(function (el) {
        el.hidden = !show;
        if (show && typeof val === 'string') el.textContent = val;
      });
    }

    function selectedValues() {
      var vals = [];
      picker.querySelectorAll('[data-opt].is-selected').forEach(function (b) {
        vals[parseInt(b.getAttribute('data-position'), 10) - 1] = b.getAttribute('data-value');
      });
      return vals;
    }

    function findVariant(vals) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options;
        if (o.length !== vals.length) continue;
        var match = true;
        for (var j = 0; j < o.length; j++) { if (o[j] !== vals[j]) { match = false; break; } }
        if (match) return variants[i];
      }
      return null;
    }

    function update() {
      var vals = selectedValues();
      var v = findVariant(vals);

      picker.querySelectorAll('[data-option-group]').forEach(function (g) {
        var sel = g.querySelector('[data-opt].is-selected');
        var lbl = g.querySelector('[data-selected-label]');
        if (sel && lbl) lbl.textContent = sel.getAttribute('data-value');
      });

      if (!v) {
        setText(atcTextEls, 'Unavailable');
        atcBtns.forEach(function (b) { b.disabled = true; });
        return;
      }

      if (idInput) idInput.value = v.id;
      setText(priceEls, v.price);
      toggle(compareEls, !!v.compare, v.compare || '');
      toggle(discountEls, v.discount != null, v.discount != null ? '-' + v.discount + '%' : '');
      toggle(dealEls, !!v.compare);
      if (stageBadge) { stageBadge.hidden = v.discount == null; if (v.discount != null) stageBadge.textContent = '-' + v.discount + '%'; }

      atcBtns.forEach(function (b) { b.disabled = !v.available; });
      setText(atcTextEls, v.available ? 'Add to cart' : 'Sold out');
      if (stockText) stockText.textContent = v.available ? (stockText.getAttribute('data-stock-in') || 'In stock') : 'Out of stock';

      if (v.image && mainImg) { mainImg.src = v.image; syncThumb(v.image); }
    }

    if (picker && variants.length) {
      picker.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-opt]');
        if (!btn) return;
        var pos = btn.getAttribute('data-position');
        picker.querySelectorAll('[data-opt][data-position="' + pos + '"]').forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
        update();
      });
      update();
    }

    // ---- sticky mobile buy bar (show when main Add-to-cart scrolls off screen) ----
    var bar = document.querySelector('[data-buybar]');
    var atcMain = document.querySelector('[data-atc-main]');
    if (bar && atcMain && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          bar.classList.toggle('is-visible', !en.isIntersecting);
        });
      }, { rootMargin: '0px 0px -15% 0px' });
      io.observe(atcMain);
    } else if (bar) {
      bar.classList.add('is-visible');
    }

    // ---- add to cart without leaving the page ----
    function refreshCartCount() {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = c.item_count;
            el.hidden = c.item_count < 1;
          });
        }).catch(function () {});
    }

    function buildToast() {
      var t = document.createElement('div');
      t.className = 'cart-toast';
      t.innerHTML =
        '<span class="cart-toast__icon" aria-hidden="true">✓</span>' +
        '<span class="cart-toast__msg"><span data-toast-text>Added to cart</span>' +
        '<small>It\'s waiting in your cart whenever you\'re ready</small></span>' +
        '<a class="btn btn--accent" href="/cart">View cart</a>';
      document.body.appendChild(t);
      return t;
    }

    var toastTimer;
    function showToast(t, msg, ok) {
      t.querySelector('[data-toast-text]').textContent = msg;
      t.classList.toggle('cart-toast--err', !ok);
      t.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 4200);
    }

    var pform = document.getElementById('ProductForm');
    if (pform && window.fetch) {
      var toast = buildToast();
      pform.addEventListener('submit', function (e) {
        e.preventDefault();
        var labels = [];
        atcTextEls.forEach(function (el) { labels.push(el.textContent); });
        atcBtns.forEach(function (b) { b.disabled = true; });
        setText(atcTextEls, 'Adding…');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(pform)
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            atcBtns.forEach(function (b) { b.disabled = false; });
            if (!res.ok) {
              atcTextEls.forEach(function (el, i) { el.textContent = labels[i] || 'Add to cart'; });
              showToast(toast, (res.d && res.d.description) || 'Could not add to cart', false);
              return;
            }
            setText(atcTextEls, 'Added ✓');
            setTimeout(function () {
              atcTextEls.forEach(function (el, i) { el.textContent = labels[i] || 'Add to cart'; });
            }, 1800);
            refreshCartCount();
            showToast(toast, 'Added to cart', true);
          })
          .catch(function () {
            atcBtns.forEach(function (b) { b.disabled = false; });
            atcTextEls.forEach(function (el, i) { el.textContent = labels[i] || 'Add to cart'; });
            showToast(toast, 'Something went wrong. Please try again.', false);
          });
      });
    }
  })();
})();
